import { useSyncExternalStore } from 'react';

export interface Toast {
  id: number;
  kind: 'info' | 'error';
  text: string;
  actions?: { label: string; run: () => void }[];
}

let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

function push(t: Omit<Toast, 'id'>, ms = 5000) {
  const id = nextId++;
  toasts = [...toasts.slice(-2), { ...t, id }];
  emit();
  setTimeout(() => dismiss(id), ms);
  return id;
}

export function dismiss(id: number) {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

type Action = { label: string; run: () => void };
export const toast = {
  info: (text: string, action?: Action | Action[]) => {
    const actions = action ? (Array.isArray(action) ? action : [action]) : undefined;
    return push({ kind: 'info', text, actions }, actions ? 7000 : 4000);
  },
  error: (text: string) => push({ kind: 'error', text }, 8000),
};

export function useToasts() {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => toasts,
  );
}
